import { preparationDepuisTache } from '@admin-pmvb/core'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { api, corps, ErreurApi, type FicheTache, lire } from '../api'
import { EnvoiDansLaTache } from '../pages/BoiteEnvoi'
import { Icone } from './Icone'

// Le courriel qu'une tâche propose (`courrielPropose`, décision du 02/11/2026) : en tête de sa
// fiche, à qui et pourquoi ; un clic, Claude le rédige d'après la tâche et son mail, avec
// l'issue de la tâche quand il partira. Il se relit et se valide ici, puis s'écrit dans les
// brouillons de la bonne boîte Gmail. Rien ne part de l'appli.

export function CourrielPropose({
  tacheId,
  proposition,
}: {
  tacheId: string
  proposition: NonNullable<FicheTache['courrielPropose']> | null
}) {
  const client = useQueryClient()
  const [cree, setCree] = useState<string | null>(null)
  const [enCours, setEnCours] = useState(false)
  const [erreur, setErreur] = useState<string | null>(null)
  if (!proposition && !cree) return null
  return (
    <section className="carte courriel-propose">
      {cree ? (
        <>
          <h2>
            <Icone nom="forward_to_inbox" /> Courriel préparé
          </h2>
          <p className="discret">
            Relire, choisir ce que devient la tâche quand il part, valider, puis l’écrire dans les
            brouillons Gmail et l’envoyer de là. L’appli voit qu’il est parti.
          </p>
          <EnvoiDansLaTache id={cree} />
        </>
      ) : (
        proposition && (
          <>
            <div className="courriel-propose-tete">
              <Icone nom="mail" />
              <div>
                <strong>Courriel proposé : {proposition.libelle}</strong>
                <div className="discret">{proposition.a}</div>
              </div>
            </div>
            <button
              type="button"
              className="bouton"
              disabled={enCours}
              onClick={async () => {
                setErreur(null)
                setEnCours(true)
                try {
                  const b = await lire(
                    api.taches[':id'].preparer.$post({
                      param: { id: tacheId },
                      json: corps(preparationDepuisTache, {
                        type: 'courriel',
                        motif: proposition.motif,
                        a: proposition.a,
                      }),
                    }),
                  )
                  setCree(b.id)
                  await client.invalidateQueries({ queryKey: ['brouillons'] })
                  await client.invalidateQueries({ queryKey: ['taches'] })
                } catch (e) {
                  setErreur(e instanceof ErreurApi ? e.message : 'Rédaction impossible.')
                } finally {
                  setEnCours(false)
                }
              }}
            >
              <Icone nom="auto_awesome" />
              {enCours ? 'Rédaction…' : 'Rédiger avec Claude'}
            </button>
            {erreur && <p className="alerte">{erreur}</p>}
          </>
        )
      )}
    </section>
  )
}
